export const environment = {
  production: false,
  backendApiUrl: 'https://api.stdg-dev.aws.private-pmideep.biz/api/v1',
  msalConfig: {
    auth: {
      clientId: '3ea8f8d4-58b8-4063-bfad-32e1b1032304',
      authority: 'https://login.microsoftonline.com/8b86a65e-3c3a-4406-8ac3-19a6b5cc52bc',
      redirectUri: 'https://stdg-dev.aws.pmicloud.biz/'
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      allowNativeBroker: false,
      logLevel: 'Info',
      piiLoggingEnabled: false,
    }
  },
  apiConfig: {
    scopes: [
      'user.read',
      'api://9fe2715e-8f7b-4f71-b4de-0dbe60c64b32/session:role-any',
      'api://1524d690-d025-44ea-ab0b-651df23e6b9c/session:role-any',
      'api://26819e7d-579e-456c-8f7a-b0d9a933fee7/session:role-any'
    ],
    uri: 'https://graph.microsoft.com/v1.0/me',
    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read']
      }
    ]
  },
  nodeScopes: {
    SUST: ['api://9fe2715e-8f7b-4f71-b4de-0dbe60c64b32/session:role-any'],
    FCD: ['api://1524d690-d025-44ea-ab0b-651df23e6b9c/session:role-any'],
    FCT: ['api://26819e7d-579e-456c-8f7a-b0d9a933fee7/session:role-any']
  },
  routes: {
    loginFailedRoute: '/loginpage'
  }
};